import moment from 'moment-jalaali';
import React, { useContext, useEffect, useState } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import discount from '../../Assets/icon/discount.png';
import tick from '../../Assets/icon/tick.svg';
import wallet from '../../Assets/icon/wallet.png';
import warning from '../../Assets/icon/warning.png';
import AvatarDefault from '../../Assets/images/AvatarDefault.jpg';
import LocalContext from '../../Context/LocalContetxt';
import StyledButton from '../../UIcomponent/Button';
import Col from '../../UIcomponent/Column';
import Image from '../../UIcomponent/Image';
import StyledInput from '../../UIcomponent/Input';
import Section from '../../UIcomponent/Section';
import Text from '../../UIcomponent/Text';
import DateTime from '../../Utility/Method/DateTime';
import { PersianMonth } from '../../Utility/Method/DateTimeConstant';
// import LocalInvoice from '../../Utility/Method/LocalInvoice'
import { PublicDic } from '../../Utility/PublicDic';
import BookingReq from '../../Utility/Requester/BookingReq';
import Arrow from './../../UIcomponent/Icon/Arrow';
import './Invoice.scss';
import { InvoiceDic } from './InvoiceDic';
import Modal from '../../UIcomponent/Modal';
import { Notify } from '../../UIcomponent/NotificationManager';
import LocalBooking from '../../Utility/Method/LocalBooking';
import Urls from '../../Utility/Urls';
import PayStatus from '../../Component/PayStatus/PayStatus';
import StyledAvatar from '../../UIcomponent/StyledAvatar';
import { getGuid } from '../../App';
import Metas from '../../Component/Metas';
const Invoice = (props) => {
  const lang = useContext(LocalContext).lang;
  const ID = props.match && props.match.params ? props.match.params.id : null;
  let localInvoice = LocalBooking.Get() || null;
  let width = window.innerWidth;
  const [couponCollapse, setCouponCollapse] = useState(false);
  const [voucherPrice, setVoucherPrice] = useState(
    localInvoice && localInvoice.VoucherPrice ? localInvoice.VoucherPrice : 0
  );
  const [VoucherCode, setVoucherCode] = useState(
    localInvoice !== null && localInvoice.VoucherCode !== undefined
      ? localInvoice.VoucherCode
      : null
  );
  const [hasVoucher, setHasVoucher] = useState(
    localInvoice !== null &&
      (localInvoice.VoucherCode === null ||
        localInvoice.VoucherCode === undefined)
      ? false
      : true
  );
  const [voucherIsSubmiting, setVoucherIsSubmiting] = useState(false);
  const [state, setState] = useState({
    readTerm: false,
    payemntBtn: {
      loading: false,
    },
  });
  const [Balance, setBalance] = useState(null);
  const [payStatus, setPayStatus] = useState(0);
  const [hasValidVoucher, setValidVoucher] = useState(false);
  const location = useLocation();
  const isTrial = localInvoice && localInvoice.isTrial;
  let localInvoiceInterval;
  let legalTime = 15 * 60 * 1 * 1000;
  useEffect(() => {
    // if (location.search.includes('status=-1')) {
    //     setPayStatus(-1)
    // }
    BookingReq.WalletBalance()
      .then((res) => {
        setBalance(res.data.Balance);
      })
      .catch((err) => {});
    if (ID) {
      localInvoice = LocalBooking.Get();
      localInvoiceInterval = localInvoice
        ? Date.now() - localInvoice.DateTime
        : 0;
      if (localInvoiceInterval >= legalTime) {
        // localStorage.removeItem(`Invoice${ID}`)
        // window.location.reload()
      }
    }
    const CheckInterval = () =>
      setInterval(() => {
        localInvoiceInterval = localInvoice
          ? Date.now() - localInvoice.DateTime
          : 0;
        if (localInvoiceInterval >= legalTime) {
          // localStorage.removeItem(`Invoice${ID}`)
          // window.location.reload()
        }
      }, 60000);
    CheckInterval();
    return () => {
      CheckInterval && clearInterval(CheckInterval);
    };
  }, []);
  const TermStateHanlder = () => {
    setState({
      ...state,
      readTerm: !state.readTerm,
    });
  };
  const payment = (ID) => {
    setState({
      ...state,
      payemntBtn: {
        ...state.payemntBtn,
        loading: true,
      },
    });
    let data = {
      TeacherID: localInvoice.TeacherID,
      LessonID: localInvoice.LessonID,
      PriceID: localInvoice.PriceID,
      TimeSlots: localInvoice.TimeSlots.map((each) => {
        return {
          From: each.date_time_from,
          To: each.date_time_to,
        };
      }),
    };
    if (hasValidVoucher) {
      if (VoucherCode) {
        if (VoucherCode.length > 0) {
          data.VoucherCode = VoucherCode;
        } else {
          data.VoucherCode = null;
        }
      } else {
        data.VoucherCode = null;
      }
    }
    if (window.ga)
      window.ga('ec:setAction', 'checkout', {
        id: getGuid(),
        step: 4,
        coupon: data.VoucherCode,
      });
    BookingReq.BookLesson(data)
      .then((res) => {
        if (res.data.Redirect !== null) {
          window.location.replace(res.data.Redirect.Action);
        } else {
          window.location.replace('/payment-success');
        }
      })
      .catch((err) => {
        // LocalBooking.Remove()
        setState({
          ...state,
          payemntBtn: {
            ...state.payemntBtn,
            loading: false,
          },
        });
        Notify('error', err.response.data.message, 4000);
      });
  };
  const voucherHanlder = (e) => {
    setVoucherCode(e.target.value);
  };
  const AddVoucher = (e) => {
    let data = {
      TeacherID: localInvoice.TeacherID,
      LessonID: localInvoice.LessonID,
      PriceID: localInvoice.PriceID,
      TimeSlots: localInvoice.TimeSlots.map((each) => {
        return {
          From: each.date_time_from,
          To: each.date_time_to,
        };
      }),
      VoucherCode,
    };
    setVoucherIsSubmiting(true);
    BookingReq.CheckoutVoucher(data)
      .then((res) => {
        setValidVoucher(true);
        localInvoice.VoucherPrice = res.data.DiscountAmount;
        localInvoice.VoucherCode = VoucherCode;
        LocalBooking.Set(localInvoice);
        setVoucherPrice(res.data.DiscountAmount);
        setVoucherIsSubmiting(false);
        setHasVoucher(true);
        Notify('success', 'کد تخفیف با موفقیت اعمال شد', 4000);
      })
      .catch((err) => {
        setValidVoucher(false);

        setVoucherIsSubmiting(false);
        Notify('error', err.response.data.message, 4000);
      });
  };
  const RemoveVoucher = () => {
    localInvoice.VoucherPrice = 0;
    localInvoice.VoucherCode = null;
    LocalBooking.Set(localInvoice);
    setVoucherPrice(0);
    setVoucherCode(null);
    setHasVoucher(false);
  };

  return (
    <>
      {!localInvoice ? (
        <Redirect to="/" />
      ) : (
        <Col xl={21} lg={22} md={22} sm={23} xs={23} className="l__Invoice">
          <Metas title="فاکتور | لینگوتاک" description="فاکتور | لینگوتاک" />

          <Col
            xl={16}
            lg={14}
            md={14}
            sm={24}
            xs={24}
            className="w__Invoice__More"
          >
            <Section
              // lang={'fa'}
              width={'100%'}
              className="c__Invoice__More__Credit"
            >
              <Col
                xl={19}
                lg={19}
                md={19}
                sm={16}
                xs={16}
                className="o__More__Credit__Title"
              >
                <Col xl={23} lg={23} md={23} sm={23} xs={23}>
                  <Image src={wallet} />
                  {InvoiceDic.walletCredit[`${lang}`]}
                </Col>
                <Col xl={23} lg={23} md={23} sm={23} xs={23}>
                  {InvoiceDic.creditAuto[`${lang}`]}
                </Col>
              </Col>

              <Col
                xl={5}
                lg={5}
                md={4}
                sm={8}
                xs={8}
                className="o__More__Credit__Desc"
              >
                {Balance ? (Balance / 10).toLocaleString(lang) : 0} تومان
              </Col>
            </Section>
            <Section
              // lang={'fa'}
              className={
                couponCollapse === false
                  ? 'c__Invoice__More__Coupon'
                  : 'c__Invoice__More__Coupon--Collapsed'
              }
            >
              <Col
                xl={23}
                lg={23}
                md={23}
                sm={23}
                xs={23}
                className="o__More__Coupon__Title"
              >
                <Col xl={24} lg={24} md={24} sm={21} xs={21}>
                  <Image src={discount} />
                  {InvoiceDic.coupon[`${lang}`]}
                </Col>
                <Col
                  onClick={() => setCouponCollapse(!couponCollapse)}
                  xl={23}
                  lg={23}
                  md={23}
                  sm={3}
                  xs={3}
                >
                  <Arrow height={150} />
                </Col>
              </Col>
              <Col
                xl={23}
                lg={23}
                md={23}
                sm={23}
                xs={23}
                className="o__More__Coupon__Desc"
              >
                {InvoiceDic.couponHelp[`${lang}`]}
              </Col>
              <Col
                xl={23}
                lg={23}
                md={23}
                sm={23}
                xs={23}
                className="o__More__Coupon__Form"
              >
                <StyledInput
                  width={'210px'}
                  onChange={(e) => {
                    voucherHanlder(e);
                  }}
                  value={VoucherCode}
                ></StyledInput>
                <StyledButton
                  primary
                  disable={!VoucherCode && voucherPrice === 0 ? true : false}
                  loading={voucherIsSubmiting}
                  onClick={
                    VoucherCode && voucherPrice !== 0
                      ? () => RemoveVoucher()
                      : (e) => AddVoucher(e)
                  }
                  style={{ margin: '0px 8px' }}
                >
                  {VoucherCode && voucherPrice !== 0
                    ? 'حذف کد تخفیف'
                    : 'اعمال کد تخفیف'}
                </StyledButton>
              </Col>
            </Section>
            <Section
              // lang={'fa'}
              className="c__Invoice__More__Terms"
            >
              <Col
                xl={23}
                lg={23}
                md={23}
                sm={23}
                xs={23}
                className="o__More__Terms__Title"
              >
                {/* <Col> */}
                <Image src={warning} />
                {PublicDic.terms[`${lang}`]}
                {/* </Col> */}
              </Col>
              <Col
                xl={23}
                lg={23}
                md={23}
                sm={23}
                xs={23}
                className="o__More__Terms__Desc"
              >
                <Text>
                  • داشتن لپ‌تاپ یا گوشی هوشمند به همراه اینترنت، برای برگزار
                  شدن کلاس شما الزامی است.
                </Text>
                <Text>
                  • اگر از لپتاپ استفاده می‌کنید، لطفا قبل از شروع کلاس، از سالم
                  بودن میکروفن و وب‌کم دستگاه خود مطمئن شوید.
                </Text>
                <Text>• لطفا به روز و ساعت کلاس رزرو شده خود دقت نمایید.</Text>
                <Text>
                  • هر گونه سوال را با بخش پشتیبانی به شماره ۲۸۴۲۴۷۷۰-۰۲۱ درمیان
                  بگذارید.
                </Text>
              </Col>
            </Section>
          </Col>
          <Col
            xl={7.5}
            lg={9.5}
            md={9.5}
            sm={24}
            xs={24}
            className="w__Invoice__Bill"
          >
            <Section
              // lang={'fa'}
              className="c__Invoice__Bill__Card"
            >
              <Col
                xl={23}
                lg={23}
                md={23}
                sm={23}
                xs={23}
                className="o__Bill__Card__Teacher"
              >
                <Col
                  xl={8}
                  lg={8}
                  md={8}
                  sm={8}
                  xs={8}
                  className="o__Card__Teacher__Avatar"
                >
                  <StyledAvatar
                    source={
                      localInvoice &&
                      localInvoice.TeacherInfo &&
                      localInvoice.TeacherInfo.Avatar &&
                      localInvoice.TeacherInfo.Avatar !== ''
                        ? Urls.avatar() + localInvoice.TeacherInfo.Avatar
                        : AvatarDefault
                    }
                  />
                  {/* <Image 
                                     /> */}
                </Col>
                <Col
                  xl={16}
                  lg={16}
                  md={16}
                  sm={16}
                  xs={16}
                  className="o__Card__Teacher__Info"
                >
                  <Text className="o__Card__Teacher__Info__Name">
                    {localInvoice.TeacherInfo.FirstName +
                      ' ' +
                      localInvoice.TeacherInfo.LastName}
                  </Text>
                  <Text className="o__Card__Teacher__Info__Session">
                    {localInvoice.TimeSlots.length} جلسه
                  </Text>
                  <Text className="o__Card__Teacher__Info__MoreDetail">
                    مشاهده جزییات
                    <Col className="o__Card__Teacher__Info__MoreDetail__Sessions">
                      {localInvoice.TimeSlots.map((time) => {
                        return (
                          <Col
                            className="o__MoreDetail__Session"
                            xl={22}
                            lg={23}
                            md={23}
                            sm={23}
                            xs={23}
                          >
                            <Col xl={11} lg={11} md={11} sm={11} xs={11}>
                              {
                                DateTime.getDayFullStr(
                                  `${moment(time.date_time_from).format('ddd')}`
                                )[`${lang}`]
                              }
                              ,{' '}
                              {
                                moment(time.date_time_from).format('jDD') +
                                  ' ' +
                                  PersianMonth[
                                    Number(
                                      moment(time.date_time_from).format('jMM')
                                    ) - 1
                                  ]
                                //  + ' ' +
                                // moment(time.date_time_from).format('jYY')
                              }
                            </Col>
                            <Col xl={11} lg={11} md={11} sm={11} xs={11}>
                              {moment(time.date_time_from).format('HH:mm') +
                                ' تا ' +
                                moment(time.date_time_to).format('HH:mm')}
                            </Col>
                          </Col>
                        );
                      })}
                    </Col>
                  </Text>
                </Col>
              </Col>
              <Col
                xl={21}
                lg={21}
                md={21}
                sm={21}
                xs={21}
                className="o__Bill__Card__Price"
              >
                <span></span>
                <Col
                  xl={24}
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  className="o__Card__Price__Session"
                >
                  <Text>{InvoiceDic.sessionPrice[`${lang}`]}</Text>
                  {!isTrial && (
                    <Text>
                      {localInvoice
                        ? (localInvoice.PayableAmount / 10).toLocaleString(lang)
                        : null}{' '}
                      تومان
                    </Text>
                  )}
                  {isTrial && <Text>رایگان</Text>}
                </Col>
                <Col
                  xl={24}
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  className="o__Card__Price__Credit"
                >
                  <Text>
                    {/* {InvoiceDic.walletCredit[`${lang}`]} */}
                    موجودی کیف پول
                  </Text>
                  <Text>{(Balance / 10).toLocaleString(lang)} تومان</Text>
                </Col>
                <Col
                  xl={24}
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  className="o__Card__Price__Credit"
                >
                  <Text>
                    {/* {InvoiceDic.walletCredit[`${lang}`]} */}
                    تخفیف
                  </Text>
                  <Text>{(voucherPrice / 10).toLocaleString(lang)} تومان</Text>
                </Col>
                <span></span>
                <Col
                  xl={24}
                  lg={24}
                  md={24}
                  sm={24}
                  xs={24}
                  className="o__Card__Price__Total"
                >
                  <Text>{InvoiceDic.paymentPrice[`${lang}`]}</Text>
                  <Text>
                    {!isTrial
                      ? hasVoucher === true
                        ? localInvoice && localInvoice.PayableAmount
                          ? (
                              (localInvoice.PayableAmount -
                                voucherPrice -
                                Balance <
                              0
                                ? 0
                                : localInvoice.PayableAmount -
                                  voucherPrice -
                                  Balance) / 10
                            ).toLocaleString(lang)
                          : 0
                        : localInvoice && localInvoice.PayableAmount
                        ? (
                            (localInvoice.PayableAmount - Balance < 0
                              ? 0
                              : localInvoice.PayableAmount - Balance) / 10
                          ).toLocaleString(lang)
                        : 0
                      : 'رایگان'}
                    {!isTrial && 'تومان'}
                  </Text>
                </Col>
              </Col>
              <Col
                xl={21}
                lg={21}
                md={21}
                sm={21}
                xs={21}
                className="o__Bill__Card__Payment"
              >
                <StyledButton
                  loading={state.payemntBtn.loading}
                  secondary
                  onClick={() => payment(ID)}
                >
                  {isTrial ? 'ثبت نهایی' : PublicDic.payment[`${lang}`]}
                </StyledButton>
              </Col>
            </Section>
          </Col>
          <Col className="c__Invoice__PayButton--RES">
            {/* <Col
                            xl={21} lg={21} md={21} sm={19} xs={19}
                            className='o__Card__Payment__Terms--RES'
                        >
                            <Col
                                className={`${state.readTerm ? 'o__Card__Payment__Terms__CheckMark--active' : 'o__Card__Payment__Terms__CheckMark'}`}
                                style={{
                                    backgroundImage: `url(${tick})`
                                }}
                                onClick={TermStateHanlder}
                            ></Col>
                            <Text
                                className='o__Card__Payment__Terms__Desc'
                            >
                                <span>{PublicDic.terms[`${lang}`]} </span>
                                {PublicDic.lingotalk[`${lang}`] + ' ' +
                                    InvoiceDic.agree[`${lang}`]}
                            </Text>
                        </Col> */}
            <StyledButton
              // primary
              disable={state.payemntBtn.loading}
              loading={state.payemntBtn.loading}
              secondary
              onClick={() => payment(ID)}
            >
              پرداخت
            </StyledButton>
          </Col>
        </Col>
      )}
      {/* <Modal
                visible={payStatus !== 0 ? true : false}
                onCancel={() => setPayStatus(0)}
            >
                <PayStatus payStatus={payStatus} />
            </Modal> */}
      {/* {width < 768 &&
                <Modal
                    visible={!state.readTerm}
                >
                    <Section
                        className='c__Invocie__Terms--RES'
                    >
                        <Col
                            xl={23} lg={23} md={23} sm={23} xs={23}
                            className='o__More__Terms__Title'
                        >
                            <Image src={warning} />
                            {PublicDic.terms[`${lang}`]}
                        </Col>
                        <Col
                            xl={23} lg={23} md={23} sm={23} xs={23}
                            className='o__More__Terms__Desc'
                        >
                            <Text>
                                یک سری قوانین داریم که خودتون سعی کنید رعایت کنید
                                </Text>
                         
                        </Col>
                        <StyledButton
                            primary
                            onClick={() => setState({ ...state, readTerm: true })}
                        >
                            قبول دارم
                    </StyledButton>
                    </Section>
                </Modal>
            } */}
    </>
  );
};

export default Invoice;
